import React, { useContext, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { BlouseContext } from "../../../context/blouseContext";
import { SliderPicker } from 'react-color';
import FabricComponent from "../fabric";

const ColorComponent=()=>{
    const {selectedBlouse,updateColor}=useContext(BlouseContext);
    const [activeItem,setActiveItem]=useState("Color");
    const [color, setColor] = useState('#FFFFFF');

    const handleActive=(value)=>{
        setActiveItem(value)
    }

    const handleChange = (selectedColor) => {
        setColor(selectedColor.hex);
    };

    const getColorUpdate=(value)=>{
        updateColor(value);
      }

    return(
        <>
        <Col>
          <Button variant={activeItem === 'Color' ? "dark mx-1":"outline-dark mx-1"} size="sm" 
          onClick={()=>handleActive("Color")} disabled={!selectedBlouse}>Color</Button>
          <Button variant={activeItem === 'Fabric' ? "dark mx-1":"outline-dark mx-1"} size="sm"
          onClick={()=>handleActive("Fabric")}  disabled={!selectedBlouse}>Fabric</Button>
          <Row>
            
              {selectedBlouse && activeItem === "Color" &&
              <Row className="p-2" onClick={()=>getColorUpdate(color)}>
                <Col>
                <SliderPicker color={color} onChange={handleChange} 
                />
                </Col>
            </Row>}
           
            {selectedBlouse && activeItem === "Fabric" &&
              <FabricComponent/>
              }
          </Row>
        </Col>
        </>
    )
}
export default ColorComponent